<template>
	<el-popover placement="bottom" trigger="click">
		<div>
			<div class="checknox-line" v-for="(item,index) in list" :key="index">
				<el-checkbox :model-value="item.show" :label="item.label" size="large" @change="changeCheck(index)" />
			</div>
		</div>
		<template #reference>
		  <i class="el-icon-s-operation" />
		</template>
	</el-popover>
</template>

<script setup>
import { defineEmits, ref } from 'vue'

const emits = defineEmits(['update:list'])
	
const props = defineProps({
	list: {
		type: Array,
		default: function(){
			return []
		}
	}
})

const changeCheck = function(index) {
	let arr = [...props.list]
	arr[index].show = !arr[index].show
	emits('update:list',arr)
}

</script>

<style scoped>
.checknox-line{
	padding: 2px 0;
}
</style>